import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const ToggleTile = gql`
  mutation ToggleTile($toggleToken: Token!) {
    toggleTile(toggleToken: $toggleToken) {
      __typename
      ... on ToggleTileSuccess {
        tile {
          __typename
          ... on ListItemTile {
            id
            status
            tileType
            title
            caption
            state
            onClick
            toggleToken
          }
        }
      }
      ... on ToggleTileError {
        ...error
      }
    }
  }
  ${error}
`;
